import {Component, Vue} from "vue-property-decorator";

@Component
export class Column extends Vue {
  render(){
    return <div class="column">{this.$slots.default}</div>;
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-73d9da09/column.tsx" });